import { createSlice } from "@reduxjs/toolkit";
import { connect } from "react-redux";

const MESSAGE_TIMEOUT_DURATION = 3000;

// @TODO: add different types of notifications (error, success, info, warning)
// @TODO: add a queue system to show multiple notifications in a row
const uiStateSlice = createSlice({
  name: "uiState",
  initialState: {
    message: "",
    messageId: undefined,
    values: undefined,
    open: false,
  },
  reducers: {
    openNotification: (state, action) => {
      const payload = action.payload;
      if (typeof payload === "string") {
        state.message = payload;
        state.messageId = undefined;
        state.values = undefined;
        state.open = true;
      } else if (
        payload &&
        typeof payload === "object" &&
        (payload.messageId || payload.message)
      ) {
        const { messageId, message, values } = payload;
        state.message = message || "";
        state.messageId = messageId;
        state.values = values;
        state.open = true;
      } else {
        state.open = true;
      }
    },
    closeNotification: (state) => {
      state.message = "";
      state.messageId = undefined;
      state.values = undefined;
      state.open = false;
    },
  },
});

// Export actions
export const { openNotification, closeNotification } = uiStateSlice.actions;

// Operations
export const showNotificationMessage = (messageOrDescriptor) => {
  return async (dispatch) => {
    dispatch(openNotification(messageOrDescriptor));
    setTimeout(() => dispatch(closeNotification()), MESSAGE_TIMEOUT_DURATION);
  };
};

/**
 *
 */
export const withShowNotificationMessage = connect(null, {
  showNotificationMessage,
});

// Export reducer
export const reducer = uiStateSlice.reducer;
